import { Button } from "react-aria-components";

import Caret from "../../icons/caret.svg?react";

import styles from "./select-trigger.module.css";

interface SelectTriggerProps {
  display?: {
    minWidth?: string;
  };
  children: React.ReactNode;
}

function SelectTrigger({ children, display }: SelectTriggerProps) {
  let style = {};
  if (display?.minWidth) {
    style = {
      minWidth: display.minWidth,
    };
  }
  return (
    <Button style={style} className={styles.trigger}>
      {children}
      <span className={styles.triggerCaret} aria-hidden="true">
        <Caret aria-hidden="true" data-testid="caret" />
      </span>
    </Button>
  );
}

export default SelectTrigger;
